import { SvgIcon, SvgIconProps } from '@mui/material';
import React from 'react';

const MenuItemPortIcon = (props: SvgIconProps) => {
  return (
    <SvgIcon {...props}>
      <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M18.4688 5.51953L10.1719 3.14922C10.0874 3.125 9.99874 3.11888 9.91172 3.13125L1.69844 4.30469C1.40106 4.34843 1.12922 4.49734 0.93226 4.7244C0.735303 4.95146 0.626287 5.24161 0.625 5.54219V14.4578C0.626287 14.7584 0.735303 15.0485 0.93226 15.2756C1.12922 15.5027 1.40106 15.6516 1.69844 15.6953L9.91172 16.8672C9.94094 16.8718 9.97043 16.8744 10 16.875C10.0582 16.8751 10.116 16.867 10.1719 16.8508L18.4688 14.4805C18.729 14.4051 18.9578 14.2476 19.1212 14.0315C19.2845 13.8153 19.3736 13.5522 19.375 13.2812V6.71875C19.3736 6.44784 19.2845 6.18467 19.1212 5.96853C18.9578 5.75239 18.729 5.59489 18.4688 5.51953ZM5 9.375H3.75C3.58424 9.375 3.42527 9.44085 3.30806 9.55806C3.19085 9.67527 3.125 9.83424 3.125 10C3.125 10.1658 3.19085 10.3247 3.30806 10.4419C3.42527 10.5592 3.58424 10.625 3.75 10.625H5V14.9047L1.875 14.4578V5.54219L5 5.09531V9.375ZM9.375 15.5297L6.25 15.0828V10.625H7.5C7.66576 10.625 7.82473 10.5592 7.94194 10.4419C8.05915 10.3247 8.125 10.1658 8.125 10C8.125 9.83424 8.05915 9.67527 7.94194 9.55806C7.82473 9.44085 7.66576 9.375 7.5 9.375H6.25V4.91719L9.375 4.47031V15.5297Z"
          fill="white"
        />
      </svg>
    </SvgIcon>
  );
};

export default MenuItemPortIcon;
